import React from 'react';
import './client.css';

function Client() {
  return (
    <div className='sponsorscroll'>
      <h2>
        Our <span> Clients</span>
      </h2>
      <div className='simage'>
        <img src={'/aseclogo.png'} alt='ASEC logo' />
        <img src={'/graceurtlogo.png'} alt='GRACEURT logo' />
        <img src={'/nuc.jpg'} alt='NUC logo' />
      </div>
    </div>
  );
}

export default Client;